import { Toast } from '@shared/components/toast/interfaces';

export const LOGIN_MODAL_SOURCES = {
  access_view: 'access_view',
  account_view: 'account_view',
} as const;

export const LOGIN_TOASTS: Record<string, Toast> = {
  notAuthorizedClerk: {
    message:
      'You are not authorized to access this application. Check your credentials.',
    type: 'error',
  },
  incorrectCredentials: {
    message: 'Email or Password incorrect.',
    type: 'error',
  },
};
